<template>
    <div>
        <v-navigation-drawer
                color="#222222"
                v-model="drawer"
                dark
                :clipped="$vuetify.breakpoint.lgAndUp"
                app
        >
            <v-list dense>
                <!--<v-list-item-group-->
                        <!--v-model="group"-->
                        <!--active-class="deep-purple&#45;&#45;text text&#45;&#45;accent-4"-->
                <!--&gt;-->

                <v-list-item
                        :key="'data-platform'"
                        link
                        :to="'/'"
                >
                    <v-list-item-action>
                        <v-icon></v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            数据大屏
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <template v-for="item in routers">
                    <v-list-item
                            :key="item.name"
                            link
                            @click="changeMenu(item)"
                    >
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.meta.title }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>

                <!--</v-list-item-group>-->
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ZMenu',
    props: {
      value: {
        type: Boolean,
        required: true,
        default: false
      }
    },
    computed: {
      ...mapGetters([
        'routers',
      ]),
      drawer: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
    },
    data: () => ({
      group:'',
      // items: [
      //   {name: 'UserManagement', meta: {title:'用户管理'}, path: "/user-management"},
      //   {name: 'DataPlatform', meta: {title:'iot大数据页面'}, path: "/data-platform"},
      //   {name: 'Tree', meta: {title:'业务树页面'}, path: "/layout/tree"},
      //   {name: 'CollectorManagement', meta: {title:'采集器管理页面'}, path: "/layout/collector-management"},
      //   {name: 'EqpMonitor', meta: {title:'采集器管理实时'}, path: "/layout/eqp-monitor"},
      // ],
    }),
    methods:{
      changeMenu(item){
        this.$store.dispatch('setCurretTitle',item.meta.title);
        this.$router.push({ path:item.path  });
        this.drawer=false;
      }
    },
    created(){
        console.log(this.routers,'vuex的路由地址');
    }
  }
</script>

<style scoped>

</style>